// i18next-extract-mark-ns-start blog
import * as React from 'react';
import { I18nextContext, useTranslation } from 'gatsby-plugin-react-i18next';
import { useContext } from 'react';
import { Link, graphql } from 'gatsby';
import Layout from '../components/Layout';
import 'pure-react-carousel/dist/react-carousel.es.css';
import { GatsbyImage } from 'gatsby-plugin-image';
import { SEO } from '../components/seo';
import seo from '../../seo.json';

const Blog = ({ data }) => {
  const { t } = useTranslation();
  const title = t('Najnovšie blogy');
  const tags = data.allTagsYaml.nodes;
  const posts = data.allMdx.nodes;
  const context = useContext(I18nextContext);

  return (
    <div className="bg-light-grey">
      <Layout>
        <div className=" md:px-6 lg:px-8 py-12 bg-white">
          <div className="max-w-6xl mx-auto">
            <h2 className="text-4xl font-bold text-center">{title}</h2>
          </div>
        </div>

        <div className="mx-auto max-w-7xl px-6 lg:px-8 pt-12 pb-16 grid grid-cols-5 gap-x-12">
          <div className="col-span-5 lg:col-span-4 space-y-10">
            {posts
              ? posts.map(post => (
                  <article
                    key={post.id}
                    className="relative bg-white px-8 shadow-custom py-6 rounded-xl isolate flex flex-col gap-8 lg:flex-row"
                  >
                    <div className="relative aspect-[16/9] sm:aspect-[2/1] lg:w-64 lg:shrink-0 align-middle">
                      <GatsbyImage
                        objectFit="scale-down"
                        className="absolute inset-0 w-full h-full"
                        // imgClassName='w-[100px]'
                        image={
                          post.frontmatter.image.childImageSharp.gatsbyImageData
                        }
                      />
                      {/*<div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />*/}
                    </div>
                    <div>
                      <div className="flex items-center gap-x-4 text-xs">
                        <time className="text-gray-500">
                          {post.frontmatter.date}
                        </time>
                      </div>
                      <div className="group relative max-w-3xl">
                        <h3 className="mt-3 text-lg font-semibold leading-6 text-gray-900 group-hover:text-gray-600">
                          <a
                            href={
                              '/' +
                              context.language +
                              '/' +
                              post.frontmatter.kind +
                              post.frontmatter.uri
                            }
                          >
                            {/* <a href={"/sk/blog"+post.frontmatter.uri}> */}
                            <span className="absolute inset-0" />
                            {post.frontmatter.title}
                          </a>
                        </h3>
                        <p className="mt-5 text-sm leading-6 text-gray-600">
                          {post.frontmatter.perex}
                        </p>
                      </div>
                      <div className="mt-6 flex border-t border-gray-900/5 pt-6">
                        <div className="relative flex items-center gap-x-4">
                          <GatsbyImage
                            objectFit="contain"
                            className="rounded-full bg-gray-50"
                            style={{ width: '2.5rem', height: '2.5rem' }}
                            image={
                              post.frontmatter.author.photo.childImageSharp
                                .gatsbyImageData
                            }
                          />
                          <div className="text-sm leading-6">
                            <p className="font-semibold text-gray-900">
                              <span className="absolute inset-0" />
                              {post.frontmatter.author.name}
                            </p>
                            <p className="text-gray-600">
                              {post.frontmatter.author.role}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </article>
                ))
              : null}
          </div>
          <div className="col-span-5 mt-8 lg:mt-0 lg:gap-3 lg:flex lg:flex-wrap lg:col-span-1 lg:content-start">
            {tags
              ? tags.map(tag => (
                  <Link
                    key={tag.uri}
                    to={'/' + context.language + '/' + tag.kind + tag.uri}
                    className="inline-flex items-center rounded-md bg-adw-blue px-4 py-2 text-sm font-medium text-gray-100 m-1 lg:m-0"
                  >
                    {tag.name}
                  </Link>
                ))
              : null}
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default Blog;

export const Head = ({ pageContext }) => {
  const language = pageContext.language || 'sk';
  return (
    <SEO
      title={seo[language]['blog.title']}
      description={seo[language]['blog.description']}
    />
  );
};

export const pageQuery = graphql`
  query ($language: String!) {
    locales: allLocale(
      filter: { ns: { in: ["common", "blog"] }, language: { eq: $language } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }

    site {
      siteMetadata {
        title
      }
    }

    allTagsYaml(filter: { language: { eq: $language } }) {
      nodes {
        name
        url
        url_pretty
        description
        uri
        language
        kind
      }
    }
    allMdx(
      filter: {
        frontmatter: {
          kind: { eq: "blog" }
          publish: { eq: true }
          language: { eq: $language }
        }
      }
      sort: { frontmatter: { date: DESC } }
    ) {
      nodes {
        frontmatter {
          kind
          language
          title
          uri
          perex
          date(locale: "sk", formatString: "MMMM DD, YYYY")
          tags {
            name
            uri
          }
          image {
            childImageSharp {
              gatsbyImageData(width: 750)
            }
          }
          author {
            name
            role
            photo {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
      }
    }
  }
`;
